import React, { Component } from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import { createStructuredSelector } from "reselect";

import Checkbox from '../components/Checkbox'

import './style.css'

class ClientPDFModal extends Component{

  constructor(props){
    super(props);
    this.state = {
      sections: this.props.children.props.children.map(o => o.key),
      modalInput: [
        {
          id: "portfolioName",
          label: props.TEXT.portfolioNamepdfLabel,
          type: "text"
        },
        {
          id: "clientName",
          label: props.TEXT.clientNamepdfLabel,
          type: "text"
        },
        {
          id: "description",
          label: props.TEXT.descriptionpdfLabel,
          type: "textarea"
        }
      ],
    }
    this.setClientPdf = this.setClientPdf.bind(this);
  }

  componentWillMount(){
    this.state.sections.filter(o => o !== this.props.TEXT.compositionBreadcrumbsLabel).forEach(s =>
      this.setClientPdf('sections', s, true))
    this.setClientPdf('sections', this.props.TEXT.compositionBreadcrumbsLabel, true)
    if(!this.props.features.clientPDFStressTests){
      this.setClientPdf('sections', this.props.TEXT.stressTestsBreadcrumbsLabel, false)
    }
    if(!this.props.features.clientPDFCustomStressTests){
      this.setClientPdf('stressTests', 'custom-stress-test', false)
    }
  }

  toggleUrlInput(urlInputVisible){
    let {modalInput} = this.state
    modalInput[2].type = urlInputVisible ? "text" : "file"
    this.setState({ 
      urlInputVisible,
      modalInput
    })
  }

  setClientPdf(key, value, bool){
    if(this.props.features.clientPDFStressTests &&
        key === 'sections' && 
        value === this.props.TEXT.stressTestsBreadcrumbsLabel){
      const stressTestsEntering = bool || !this.props.clientPdf.sections[this.props.TEXT.stressTestsBreadcrumbsLabel]
      // stressTests entering ? check unchecked : uncheck checked
      Object.keys(this.props.stressTests)
        .filter(o => this.props.clientPdf.stressTests[o] !== stressTestsEntering)
        .forEach(st => {
          this.setClientPdf('stressTests', st, stressTestsEntering)
        })
      if(this.props.features.clientPDFCustomStressTests){
        this.setClientPdf('stressTests', 'custom-stress-test', stressTestsEntering)
      }
    }

    this.props.setClientPdf(key, value, bool)
  }

  render(){
    const { stressTests, clientPdf, customStressTestIsOpen, TEXT, features } = this.props;
    const { sections } = this.state;
    const { setClientPdf } = this;

    return (<div className="client-pdf-modal">
      <div className="header">{TEXT.clientReadypdfTitle}</div>
      <table>
      <tbody>
      {clientPdf.allowClientLogo && <tr>
        <td className="label">
          <label htmlFor="clientLogo">{TEXT.yourLogoLabel}</label>
        </td>
        <td className="input input-file">
          <ClientPDFModalLogo 
            setClientPdf={setClientPdf} 
            clientPdf={clientPdf} />
        </td>
      </tr>}
      {this.state.modalInput.map(mi => <tr key={mi.id}>
        <td className="label">
          <label htmlFor={mi.id}>{mi.label}</label>
        </td>
        <td className={"input input-"+mi.type}>
          <div>
            {mi.type === "textarea" 
              ? <textarea 
                  onBlur={event => setClientPdf(mi.id, event.target.value)}
                  id={mi.id}></textarea>
              : <input 
                  id={mi.id} 
                  type={mi.type}
                  onBlur={event => {
                    setClientPdf(mi.id, event.target.value)
                  }} />}
          </div>
        </td>
      </tr>)}
      <tr>
        <td className="label">
          <span>PDF Customization</span>
        </td>
        <td className="input">
          {[ ...sections.filter(s => s !== TEXT.stressTestsBreadcrumbsLabel && s !== TEXT.compositionBreadcrumbsLabel) ].map(st => 
            <div key={st} className="sections-checkbox">
              <Checkbox 
                onChange={value => setClientPdf('sections', st, !clientPdf.sections[st])}
                id={st}
                value={clientPdf.sections[st]}
                label={st} />
            </div>)}
        </td>        
      </tr>
      {!features.clientPDFStressTests ? null :
        <tr>
          <td></td>
          <td className="input">
            <div key="stress_tests" className="sections-checkbox">
              <Checkbox 
                onChange={value => setClientPdf('sections', TEXT.stressTestsBreadcrumbsLabel, !clientPdf.sections[TEXT.stressTestsBreadcrumbsLabel])}
                id="stress_tests"
                value={clientPdf.sections[TEXT.stressTestsBreadcrumbsLabel]}
                label={TEXT.stressTestsBreadcrumbsLabel} />
            </div>
            {Object.keys(stressTests).map(st => 
              <div key={st} className="stress-test-checkbox">
                <Checkbox 
                  onChange={value => setClientPdf('stressTests', st, !clientPdf.stressTests[st])}
                  id={st}
                  value={clientPdf.stressTests[st]}
                  label={stressTests[st].title} />
              </div>)}
            {features.clientPDFCustomStressTests && customStressTestIsOpen
              ? <div className="stress-test-checkbox">
                  <Checkbox 
                    onChange={value => setClientPdf('stressTests', 'custom-stress-test', !clientPdf.stressTests["custom-stress-test"])}
                    id={'custom-stress-test'}
                    value={clientPdf.stressTests["custom-stress-test"]}
                    label='Custom Stress Test' />
                </div>
              : null}
          </td>
        </tr>}
      </tbody>
      </table>
    </div>)
  }
}

const uploadButton = (text, action, active) => (<div 
  className={Classnames("upload-button", { "highlight": active })}
  onClick={action}>{text}</div>)

const ClientPDFModalLogo = props => (
  <div className="client-pdf-modal-logo">
    <div className="logo-preview">
      <img alt="Logo preview" src={props.clientPdf[props.clientPdf.logoKey] || props.clientPdf.defaultLogo} />
    </div>
    <div className="right-float saved-buttons">
      {uploadButton("default", 
        () => props.setClientPdf("logoKey", "defaultLogo"),
        props.clientPdf.logoKey === "defaultLogo")}
      {uploadButton("saved",
        () => props.setClientPdf("logoKey", "savedLogo"),
        props.clientPdf.logoKey === "savedLogo")}
    </div>
    <div className="upload-specific-button">
      <input 
        id="clientLogoFile"
        type="file"
        accept="image/png, image/jpeg"
        className='upload-button-input'
        onChange={event => {   
          var reader = new FileReader()
          reader.onload = e => {
            props.setClientPdf("clientLogo", e.target.result);
            props.setClientPdf("logoKey", "clientLogo");
            document.querySelector("input#clientLogoFile").value = null;
          }
          reader.readAsDataURL(event.target.files[0])
        }} />
      {uploadButton("upload", () => {
        document.querySelector('input#clientLogoFile').click()
      })}
      {/* <input 
        id="clientLogoText"
        placeholder="paste URL here"
        type="text" />
      {uploadButton("submit", () => {
        props.setClientPdf("clientLogo", document.querySelector('input#clientLogoText').value)
        props.setClientPdf("logoKey", "clientLogo")
      })} */}
    </div>
  </div>
);

const mapStateToProps = createStructuredSelector({
  stressTests: state => state.stressTestKeys,
  clientPdf: state => state.clientPdf,
  customStressTestIsOpen: state => state.customStressTestIsOpen,
  TEXT: state => state.complianceText,
  features: state => state.features,
});

const mapDispatchToProps = dispatch => ({
  setClientPdf: (key, value, bool) => dispatch({ type: 'SET_CLIENT_PDF', key, value, bool })
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientPDFModal);



// WEBPACK FOOTER //
// ./src/Nav/ClientPDFModal.js